export class ClassroomJoinState {
	public joinError: boolean = false;
}